import switchTeamOnErrorDialogTemplate from './switch-team-on-error-dialog.tpl.html';
import { modalComponentModule } from '../modal/modal';
import { impersonateServiceModule } from '../../services/impersonate-service/impersonate-service';
import { appAlertComponentModule } from '../app-alert/app-alert';

export const switchTeamOnErrorDialogComponentModule = angular
  .module('Q.components.switch-team-on-error-dialog', [
    modalComponentModule,
    impersonateServiceModule,
    appAlertComponentModule,
  ])

  .factory('switchTeamOnErrorDialog', function changeTeamDialog($modal) {
    return {
      open: (url, switchTeam, stateOnError) => {
        return $modal.openOnce('switchTeamOnErrorDialog', {
          template: switchTeamOnErrorDialogTemplate,
          resolve: {
            url: () => url,
            switchTeam: () => switchTeam,
            stateOnError: () => stateOnError,
          },
          controller: 'SwitchTeamOnErrorDialogCtrl',
          controllerAs: '$ctrl',
        });
      },
    };
  })

  .controller(
    'SwitchTeamOnErrorDialogCtrl',
    function SwitchTeamOnErrorDialogCtrl(
      $scope,
      $modalInstance,
      impersonateService,
      url,
      switchTeam,
      stateOnError,
      appAlert,
    ) {
      const ctrl = this;

      ctrl.switchTeam = switchTeam;
      ctrl.itemLabel = stateOnError.itemLabel || 'item';

      ctrl.switch = () => {
        ctrl.disabled = true;
        let impersonationPromise;
        if (impersonateService.isStaff()) {
          impersonationPromise = impersonateService.impersonateStaff(
            switchTeam.id,
            url,
          );
        } else {
          impersonationPromise = impersonateService.switchTeam(
            switchTeam.id,
            url,
          );
        }
        impersonationPromise
          .then(() => {
            $modalInstance.close();
          })
          .catch(appAlert.modelError)
          .finally(() => {
            ctrl.disabled = false;
          });
      };

      ctrl.cancel = $modalInstance.dismiss;
    },
  );
